var _circle, _circle2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuplicateRecords(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 25.3124,
    cy: 25.142,
    r: 24.7533,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.9472,
    cy: 31.5073,
    r: 18.3882,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6707 7.81502C11.9791 7.81502 12.2291 7.56502 12.2291 7.25663C12.2291 6.94824 11.9791 6.69824 11.6707 6.69824C11.3623 6.69824 11.1123 6.94824 11.1123 7.25663C11.1123 7.56502 11.3623 7.81502 11.6707 7.81502Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2815 34.0592C39.5899 34.0592 39.8399 33.8092 39.8399 33.5008C39.8399 33.1924 39.5899 32.9424 39.2815 32.9424C38.9732 32.9424 38.7232 33.1924 38.7232 33.5008C38.7232 33.8092 38.9732 34.0592 39.2815 34.0592Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1964 29.7264H19.1595C18.4661 29.7264 17.8987 29.1591 17.8987 28.4657V9.4287C17.8987 8.7353 18.4661 8.16797 19.1595 8.16797H38.1964C38.8898 8.16797 39.4572 8.7353 39.4572 9.4287V28.4341C39.4572 29.1591 38.8898 29.7264 38.1964 29.7264ZM20.4202 27.1734H36.9042V10.7209H20.4202V27.1734ZM31.3885 35.6518V32.3109C31.3885 31.7751 30.9473 31.3653 30.443 31.3653C29.9387 31.3653 29.4974 31.8066 29.4974 32.3109V35.2736H12.3831V18.1592H15.3142C15.8501 18.1592 16.2598 17.718 16.2598 17.2137C16.2598 16.7094 15.8185 16.2681 15.3142 16.2681H11.9733C11.1538 16.2681 10.4604 16.93 10.4604 17.781V35.7148C10.4604 36.5028 11.1223 37.1647 11.9733 37.1647H29.9072C30.7266 37.1647 31.3885 36.5028 31.3885 35.6518Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateRecords);
export default __webpack_public_path__ + "static/media/Duplicate Records.48e1f6e32a293258a42dd6e22d44e74f.svg";
export { ForwardRef as ReactComponent };